import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ProgressSpinner from './ProgressSpinner';


const ProgressBarStep = (props) => {
  const spinnerItemClassName = classnames('spinner-item', {
    completed: props.completed,
  });
  return (
    <li className={spinnerItemClassName}>

      {props.completed &&
        <div
          className="loading-complete-wrapper"
        >
          <img
            alt="Done"
            className="progress-complete"
            src="//cdn.smartresumewizard.com/images/icons/check-mark-2x.png"
          />
        </div>
      }

      {!props.completed &&
        <ProgressSpinner
          started={props.started}
          animationTime={props.animationTime}
        />
      }

      <div className="progess-bar-step-text">
        {props.text}
      </div>
    </li>
  );
};

ProgressBarStep.propTypes = {
  animationTime: PropTypes.number.isRequired,
  started: PropTypes.bool,
  completed: PropTypes.bool,
  text: PropTypes.string,
};

ProgressBarStep.defaultProps = {
  completed: false,
  started: false,
  text: '',
};

export default ProgressBarStep;



// WEBPACK FOOTER //
// ./src-react/ExportProgressBar/ProgressBarStep.jsx